/**
 * Generated by '@kontent-ai/model-generator@6.5.1'
 */
export const collections = {
    /**
     * AIGWO Qualifying Portal
     */
    aigwo_qualifying_portal: {
        codename: 'aigwo_qualifying_portal',
        id: 'f88eb823-fdc4-4c0b-be28-0adf950e92d1',
        name: 'AIGWO Qualifying Portal'
    },

    /**
     * Default
     */
    default: {
        codename: 'default',
        id: '00000000-0000-0000-0000-000000000000',
        name: 'Default'
    },

    /**
     * Player Portal   AIG Women s Open
     */
    player_portal___aig_women_s_open: {
        codename: 'player_portal___aig_women_s_open',
        id: '6d8f67db-7eb5-4a28-9783-936b0136346e',
        name: "Player Portal - AIG Women's Open"
    },

    /**
     * Player Portal   The Open
     */
    player_portal___the_open: {
        codename: 'player_portal___the_open',
        id: 'e295e086-2d6f-43ca-93be-eace249db2f1',
        name: 'Player Portal - The Open'
    },

    /**
     * Qualifying Portal
     */
    qualifying_portal: {
        codename: 'qualifying_portal',
        id: '88ea949f-a80b-4fb7-8f70-fa8eb04675d8',
        name: 'Qualifying Portal'
    }
} as const;
